import React from 'react'
import Container from 'saur_ui_library/src/Atoms/Container/Container';

type SaurIconProps = {
  color: string
  content?: 'header' | 'register' | 'footer' | 'login'
}

const SaurIcon: React.FC<SaurIconProps> = ({ color, content}) => {
  return (
    <Container className={`sds-saur-icon-container ${content}`}>
<svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
viewBox="0 0 86.52 57.58" fill={color} >
<g id="DESIGN">
<g>
<path fill={color} d="M38.5,31.4v-3h0.1c1.3,1.4,2.9,3.1,4.6,3.1c1,0,2-0.5,2-1.7c0-1.2-1.1-1.6-3.1-2.3c-2.4-0.8-3.9-1.9-3.9-3.8
c0-2.2,1.9-3.5,4.7-3.5c1.1,0,2.6,0.3,4.1,0.9v2.9H47c-1.2-1.5-2.7-2.9-4.3-2.9c-1,0-1.9,0.5-1.9,1.5c0,1.2,1.3,1.5,3.1,2.2
c2.7,0.9,3.7,2,3.7,3.8c0,2.6-2.2,3.8-4.5,3.8C41.8,32.4,40.3,32.1,38.5,31.4z"/>
<path fill={color} d="M48.8,28.8c0-1.9,1.2-3.1,3.2-3.6c2.2-0.5,3.5,0.7,3.5,0.7l0,0.1c-2.3-0.3-3.5,0.9-3.5,2.4
c0,1.4,1,2.4,2.3,2.4c0.7,0,1.4-0.4,1.9-1v0v-5.8c0-1.7-0.7-2.7-1.6-2.7c-1.4,0-4.3,2.3-4.8,2.9h-0.1v-3c1.9-0.6,3.8-0.9,5-0.9
c2.9,0,4.3,1.5,4.3,3.8v5.3c0,1.3,0.5,1.8,1.5,1.4l0,0.1c-0.2,0.9-1,1.6-2.2,1.6c-1.2,0-2-0.7-2.2-1.8c-0.7,0.9-1.8,1.8-3.5,1.8
C50.1,32.4,48.8,30.6,48.8,28.8z"/>
<path fill={color} d="M61.6,28.4V24c0-1.5-0.5-3-0.6-3.5v-0.1h3.5V28c0,1.8,1.1,2.4,2.2,2.4c0.5,0,1-0.1,1.5-0.4l0.1,0.1
c0,0-0.7,2.2-2.9,2.2C63.1,32.4,61.6,30.8,61.6,28.4z M69.3,30.1c0-0.3-0.1-1-0.1-1.5V24c0-1.5-0.5-3-0.6-3.5v-0.1h3.5v8.2
c0,1.5,0.5,3.1,0.6,3.5v0.1h-2.9C69.6,31.8,69.4,31,69.3,30.1z"/>
<path fill={color} d="M74.1,32.1c0.1-0.4,0.6-1.9,0.6-3.5V24c0-1.5-0.5-3.1-0.6-3.5v-0.1h3.5v8.2c0,1.5,0.5,3.1,0.5,3.5v0.1
L74.1,32.1L74.1,32.1z M78.4,22.7L78.4,22.7c-0.1-0.1,0.6-2.5,2.7-2.6c0.4,0,0.9,0.1,1.4,0.2L82,23.6h-0.1
C81,22.8,79.7,22.2,78.4,22.7z"/>
</g>
<g>
<path fill="#00b2a9" d="M19.2,27.3h4.4c1.2,0,2.4,0.3,3.4,0.9c-0.3-1.6-1.7-2.9-3.4-2.9h-4.4c-1.2,0-2.4-0.3-3.4-0.9
C16.1,26.1,17.5,27.3,19.2,27.3z"/>
<path fill="#00b2a9" d="M19.2,32.3h4.4c1.7,0,3.1-1.2,3.4-2.9c-1,0.6-2.2,0.9-3.4,0.9h-4.4c-1.2,0-2.4-0.3-3.4-0.9
C16.1,31,17.5,32.3,19.2,32.3z"/>
<path fill="#00b2a9" d="M23.6,22.4c1.2,0,2.4,0.3,3.4,0.9c-0.3-1.6-1.7-2.9-3.4-2.9h-4.4c-1.7,0-3.1,1.2-3.4,2.9
c1-0.6,2.2-0.9,3.4-0.9H23.6z"/>
<path fill="#00b2a9" d="M18.9,38.1c-3.2,0-6.4-0.6-9.3-1.6c2.4,2.2,5.7,3.6,9.3,3.6h5.1c3.6,0,6.8-1.4,9.3-3.6c-2.9,1-6,1.6-9.3,1.6
H18.9z"/>
<path fill="#00b2a9" d="M23.9,14.5c3.2,0,6.4,0.6,9.3,1.6c-2.4-2.2-5.7-3.6-9.3-3.6h-5.1c-3.6,0-6.8,1.4-9.3,3.6c2.9-1,6-1.6,9.3-1.6
H23.9z"/>
<path fill="#00b2a9" d="M23.6,16.5h-4.4c-2.4,0-4.5,1.2-5.7,3.1c1.7-0.7,3.5-1.1,5.4-1.1h5.1c1.9,0,3.7,0.4,5.4,1.1
C28.1,17.7,26,16.5,23.6,16.5z"/>
<path fill="#00b2a9" d="M19.2,36.2h4.4c2.4,0,4.5-1.2,5.7-3.1c-1.7,0.7-3.5,1.1-5.4,1.1h-5.1c-1.9,0-3.7-0.4-5.4-1.1
C14.7,35,16.8,36.2,19.2,36.2z"/>
</g>
<g>
<path fill={color} d="M39.5,45.1h-0.6v-4.6h2.6v0.5h-2v1.6h1.9v0.5h-1.9V45.1z"/>
<path fill={color} d="M44,41.5c0.2,0,0.3,0,0.4,0l-0.1,0.5c-0.1,0-0.3,0-0.4,0c-0.2,0-0.4,0.1-0.5,0.2c-0.2,0.1-0.3,0.2-0.4,0.4
s-0.1,0.4-0.1,0.6v1.9h-0.6v-3.5h0.5l0.1,0.6h0c0.1-0.2,0.3-0.4,0.5-0.5C43.5,41.6,43.7,41.5,44,41.5z"/>
<path fill={color} d="M47.3,45.1l-0.1-0.5h0c-0.2,0.2-0.3,0.4-0.5,0.4c-0.2,0.1-0.4,0.1-0.7,0.1c-0.3,0-0.6-0.1-0.8-0.3
c-0.2-0.2-0.3-0.4-0.3-0.8c0-0.7,0.6-1.1,1.7-1.1l0.6,0v-0.2c0-0.3-0.1-0.5-0.2-0.6S46.7,42,46.4,42c-0.2,0-0.4,0-0.5,0.1
s-0.3,0.1-0.5,0.2l-0.2-0.4c0.2-0.1,0.4-0.2,0.6-0.2c0.2-0.1,0.4-0.1,0.6-0.1c0.4,0,0.7,0.1,0.9,0.3c0.2,0.2,0.3,0.5,0.3,0.9v2.4
H47.3z M46.1,44.7c0.3,0,0.6-0.1,0.8-0.3c0.2-0.2,0.3-0.4,0.3-0.7v-0.3l-0.5,0c-0.4,0-0.7,0.1-0.9,0.2c-0.2,0.1-0.3,0.3-0.3,0.5
c0,0.2,0.1,0.3,0.2,0.4C45.8,44.6,45.9,44.7,46.1,44.7z"/>
<path fill={color} d="M51.3,45.1v-2.2c0-0.3-0.1-0.5-0.2-0.6S50.8,42,50.5,42c-0.4,0-0.6,0.1-0.8,0.3c-0.2,0.2-0.2,0.5-0.2,1v1.8
h-0.6v-3.5h0.5l0.1,0.5h0c0.1-0.2,0.3-0.3,0.5-0.4c0.2-0.1,0.4-0.1,0.6-0.1c0.4,0,0.7,0.1,1,0.3c0.2,0.2,0.3,0.5,0.3,1v2.3H51.3z"
/>
<path fill={color} d="M54.5,45.1c-0.5,0-0.9-0.2-1.2-0.5c-0.3-0.3-0.4-0.7-0.4-1.3c0-0.6,0.1-1,0.4-1.3s0.7-0.5,1.2-0.5
c0.2,0,0.3,0,0.5,0.1c0.2,0,0.3,0.1,0.4,0.1l-0.2,0.5C55,42.1,54.8,42,54.5,42c-0.4,0-0.6,0.1-0.8,0.3c-0.2,0.2-0.2,0.5-0.2,1
c0,0.4,0.1,0.7,0.2,1c0.2,0.2,0.4,0.3,0.7,0.3c0.3,0,0.6-0.1,0.9-0.2v0.5C55.2,45.1,54.9,45.1,54.5,45.1z"/>
<path fill={color} d="M57.8,45.1c-0.5,0-0.9-0.2-1.2-0.5c-0.3-0.3-0.4-0.8-0.4-1.3c0-0.6,0.1-1,0.4-1.3s0.7-0.5,1.1-0.5
c0.4,0,0.8,0.1,1,0.4c0.3,0.3,0.4,0.7,0.4,1.1v0.3h-2.4c0,0.4,0.1,0.7,0.3,0.9c0.2,0.2,0.5,0.3,0.8,0.3c0.2,0,0.4,0,0.5,0
c0.2,0,0.4-0.1,0.6-0.2v0.5c-0.2,0.1-0.4,0.1-0.5,0.2C58.3,45.1,58.1,45.1,57.8,45.1z M57.7,42c-0.3,0-0.5,0.1-0.6,0.3
s-0.3,0.4-0.3,0.7h1.8c0-0.3-0.1-0.6-0.2-0.7C58.2,42.1,58,42,57.7,42z"/>
</g>
</g>
<g id="GRID">
</g>
</svg>
    </Container>
  )
}

export default SaurIcon
